module.exports = __webpack_public_path__ + "img/munakata2.7d5a2812.jpg";